<template>
  <div>
    <v-dialog :value="dialogModel" :persistent="persistent">
      <v-card class="pa-3">
        <v-form v-if="!loading" ref="form" v-model="valid">
          <div class="text-justify text-general-module ma-4">
            <span class="ml-4 mr-4">FOTOS DEL NEGOCIO</span>
            <span class="ml-4 mr-4">
              <br />Requisitos para subir fotos:<br />
              <ul>
                <li>Solo acepta formato jpg y png.</li>
                <li>Máximo del peso por foto es de 5MB.</li>
                <li>Tomar fotos legibles.</li>
                <li v-if="document?.last_photo_update">
                  Última Actualización: {{ document.last_photo_update }}
                </li>
              </ul>
            </span>
          </div>
          <v-row dense justify="center">
            <v-col cols="12" lg="2" md="4" sm="6" align="left">
              <label for="" class="mb-2 text-table-profile ml-10 mr-10"
                >Fachada <v-icon>mdi-image</v-icon></label
              >
              <v-file-input
                v-model="form.facade_photo"
                :rules="fileRules"
                class="ml-10 mr-10"
                solo
                placeholder="Fachada"
              />
              <a
                v-if="document?.facade_photo"
                class="mb-2 text-table-profile ml-10 mr-10"
                :href="apiUrl + '/' + document?.facade_photo"
                target="_blank"
              >
                <v-img
                  position="center"
                  contain
                  height="250"
                  :src="apiUrl + '/' + document?.facade_photo"
                />
              </a>
            </v-col>

            <v-col cols="12" lg="2" md="4" sm="6" align="left">
              <label for="" class="mb-2 text-table-profile ml-10 mr-10"
                >Exhibición <v-icon>mdi-image</v-icon></label
              >
              <v-file-input
                v-model="form.display_photo"
                :rules="fileRules"
                class="ml-10 mr-10"
                solo
                placeholder="Exhibición"
              />
              <a
                v-if="document?.display_photo"
                class="mb-2 text-table-profile ml-10 mr-10"
                :href="apiUrl + '/' + document?.display_photo"
                target="_blank"
              >
                <v-img
                  position="center"
                  contain
                  height="250"
                  :src="apiUrl + '/' + document?.display_photo"
              /></a>
            </v-col>

            <v-col cols="12" lg="2" md="4" sm="6" align="left">
              <label for="" class="mb-2 text-table-profile ml-10 mr-10"
                >Exhibición Derecha <v-icon>mdi-image</v-icon></label
              >
              <v-file-input
                v-model="form.right_display_photo"
                :rules="fileRules"
                class="ml-10 mr-10"
                solo
                placeholder="Exhibición Derecha"
              />
              <a
                v-if="document?.right_display_photo"
                class="mb-2 text-table-profile ml-10 mr-10"
                :href="apiUrl + '/' + document?.right_display_photo"
                target="_blank"
              >
                <v-img
                  position="center"
                  contain
                  height="250"
                  :src="apiUrl + '/' + document?.right_display_photo"
                />
              </a>
            </v-col>

            <v-col cols="12" lg="2" md="4" sm="6" align="left">
              <label for="" class="mb-2 text-table-profile ml-10 mr-10"
                >Exhibición Izquierda <v-icon>mdi-image</v-icon></label
              >
              <v-file-input
                v-model="form.left_display_photo"
                :rules="fileRules"
                class="ml-10 mr-10"
                solo
                placeholder="Exhibición Izquierda"
              />
              <a
                v-if="document?.left_display_photo"
                class="mb-2 text-table-profile ml-10 mr-10"
                :href="apiUrl + '/' + document?.left_display_photo"
                target="_blank"
              >
                <v-img
                  position="center"
                  contain
                  height="250"
                  :src="apiUrl + '/' + document?.left_display_photo"
                />
              </a>
            </v-col>

            <v-col cols="12" lg="2" md="4" sm="6" align="left">
              <label for="" class="mb-2 text-table-profile ml-10 mr-10"
                >Exhibición central <v-icon>mdi-image</v-icon></label
              >
              <v-file-input
                v-model="form.indoor_photo"
                :rules="fileRules"
                class="ml-10 mr-10"
                solo
                placeholder="Exhibición central "
              />
              <a
                v-if="document?.indoor_photo"
                class="mb-2 text-table-profile ml-10 mr-10"
                :href="apiUrl + '/' + document?.indoor_photo"
                target="_blank"
              >
                <v-img
                  position="center"
                  contain
                  height="250"
                  :src="apiUrl + '/' + document?.indoor_photo"
              /></a>
            </v-col>

            <v-col cols="12" lg="2" md="4" sm="6" align="left">
              <label for="" class="mb-2 text-table-profile ml-10 mr-10"
                >Bodega: <v-icon>mdi-image</v-icon></label
              >
              <v-file-input
                v-model="form.bar_photo"
                :rules="fileRules"
                class="ml-10 mr-10"
                solo
                placeholder="Bodega:"
              />
              <a
                v-if="document?.bar_photo"
                class="mb-2 text-table-profile ml-10 mr-10"
                :href="apiUrl + '/' + document?.bar_photo"
                target="_blank"
              >
                <v-img
                  position="center"
                  contain
                  height="250"
                  :src="apiUrl + '/' + document?.bar_photo"
                />
              </a>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" offset="4">
              <v-row>
                <v-col cols="12" md="6">
                  <v-btn
                    :disabled="loading || !valid"
                    depressed
                    color="success"
                    class="justify-text"
                    large
                    @click="validateForm()"
                  >
                    Confirmar
                    <v-icon style="margin-left: 0.5em"> mdi-check-bold </v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12" md="6">
                  <v-btn
                    depressed
                    color="error"
                    class="justify-text"
                    large
                    @click="close()"
                  >
                    Cancelar
                    <v-icon style="margin-left: 0.5em">
                      mdi-window-close
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
        <div v-else>
          <v-progress-circular indeterminate color="primary" class="ma-3" />
        </div>
        <v-divider />
        <!-- signage -->
        <h3 class="my-8">Rotulado</h3>
        <v-form ref="signagePhotosForm" v-model="signagePhotos.valid">
          <v-row dense justify="center">
            <v-col
              v-for="(item, index, i) in signagePhotos.form"
              :key="index"
              cols="6"
              sm="6"
              md="3"
            >
              <label class="mb-2 text-table-profile ml-10 mr-10">
                Rotulado foto {{ i + 1 }}
                <v-icon>mdi-image</v-icon>
              </label>
              <v-file-input
                v-model="signagePhotos.form[index]"
                solo
                accept="image/png, image/jpeg"
                prepend-icon="mdi-camera"
                :disabled="signagePhotos.loading"
                :loading="signagePhotos.loading"
                :rules="signagePhotos.fileRules"
                class="ml-10 mr-10"
                :placeholder="`Rotulado foto ${i + 1}`"
              />
              <a
                v-if="document[index]"
                class="mb-2 text-table-profile ml-10 mr-10"
                :href="`${apiUrl}/${document[index]}`"
                target="_blank"
              >
                <v-img
                  position="center"
                  contain
                  height="250"
                  :src="`${apiUrl}/${document[index]}`"
                />
              </a>
            </v-col>
          </v-row>
          <alert-prominent
            v-if="signagePhotos.error"
            class="mt-4"
            :message="signagePhotos.error"
          />
          <v-btn
            :disabled="signagePhotos.loading || !signagePhotos.valid"
            :loading="signagePhotos.loading"
            depressed
            color="success"
            large
            @click="updateSignagePhotos()"
          >
            Agregar Rotulado
            <v-icon>mdi-check-bold</v-icon>
          </v-btn>
          <v-btn
            class="ma-2"
            :disabled="signagePhotos.loading"
            depressed
            color="error"
            large
            @click="close()"
          >
            Cancelar
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from '@/plugins/axios';
  import dates from '@/mixins/dates.js';

  import AlertProminent from '../AlertProminent.vue';

  export default {
    name: 'UpdateCustomerImagesForm',
    components: {
      AlertProminent,
    },
    mixins: [dates],
    props: {
      customerId: {
        type: Number,
        default: 0,
      },
      userId: {
        type: Number,
        default: 0,
      },
      document: {
        type: Object,
        default() {
          return {
            facade_photo: '',
            indoor_photo: '',
            bar_photo: '',
            display_photo: '',
            left_display_photo: '',
            right_display_photo: '',
            storefront_signage_photo1: '',
            storefront_signage_photo2: '',
            storefront_signage_photo3: '',
          };
        },
      },
      persistent: {
        type: Boolean,
        default: true,
      },
      dialogModel: Boolean,
    },
    data() {
      return {
        form: {},
        apiUrl: process.env.VUE_APP_FILES_URL,
        loading: false,
        fileRules: [(v) => !!v || 'Este campo es requerido'],
        valid: false,
        signagePhotos: {
          formValid: false,
          loading: false,
          valid: false,
          error: '',
          form: {
            storefront_signage_photo1: '',
            storefront_signage_photo2: '',
            storefront_signage_photo3: '',
          },
          fileRules: [(v) => !!v || 'Este campo es requerido'],
        },
      };
    },
    mounted() {
      this.initSignagePhotosForm();
    },
    methods: {
      validate() {
        this.$refs.form.validate();
      },
      reset() {
        this.$refs.form.reset();
      },
      resetValidation() {
        this.$refs.form.resetValidation();
      },

      close() {
        this.form = {};
        this.initSignagePhotosForm();
        this.$emit('closeModal');
      },

      validateForm() {
        this.validate();
        if (this.valid) {
          this.updatePhotos();
          this.reset();
        }
      },
      initSignagePhotosForm() {
        this.signagePhotos.valid = false;
        this.signagePhotos.error = '';
        this.signagePhotos.form = {
          storefront_signage_photo1: '',
          storefront_signage_photo2: '',
          storefront_signage_photo3: '',
        };
      },

      async updateSignagePhotos() {
        this.$refs.signagePhotosForm.validate();
        if (!this.signagePhotos.valid) return null;
        this.signagePhotos.error = '';
        this.signagePhotos.loading = true;
        var form = new FormData();
        for (let index = 1; index < 4; index++) {
          form.append(
            `storefront_signage_photo${index}`,
            this.signagePhotos.form[`storefront_signage_photo${index}`]
          );
        }
        form.append('userId', this.userId); // id from users table
        try {
          const response = await axios.post(
            '/seller/home/customer-gallery/update-signage-photos',
            form
          );
          const newDocuments = response.data.document;
          this.signagePhotos.form = response.data.signagePhotos;
          this.$emit('updatedPhotos', newDocuments);
          this.$swal({
            title: 'Rotulado actualizado correctamente',
            icon: 'success',
            type: 'success',
          });
        } catch (error) {
          this.signagePhotos.loading = false;
          this.signagePhotos.error =
            'Hubo un problema al cargar las imágenes de rotulado. Por favor, intente de nuevo mas tarde.';
        } finally {
          this.signagePhotos.loading = false;
          this.$refs.signagePhotosForm.reset();
        }
      },
      updatePhotos() {
        this.loadPhotos = true;
        var ed = new FormData();
        ed.append('indoor_photo', this.form.indoor_photo);
        ed.append('facade_photo', this.form.facade_photo);
        ed.append('bar_photo', this.form.bar_photo);
        ed.append('display_photo', this.form.display_photo);
        ed.append('left_display_photo', this.form.left_display_photo);
        ed.append('right_display_photo', this.form.right_display_photo);
        ed.append('user_id', this.userId); // id de users
        ed.append('customer_id', this.customerId); // id de cliente. NO SAP
        axios
          .post('/seller/home/customer-gallery/update', ed)
          .then((res) => {
            if (res.data.success) {
              this.$swal({
                title: 'Datos actualizados',
                icon: 'success',
                type: 'succes',
              }).then(() => {
                const newDocuments = res.data.document;
                this.$emit('updatedPhotos', newDocuments);
                this.loading = false;
              });
            }
            this.loading = false;
          })
          .catch((err) => {
            this.$swal({
              title: 'hubo problemas al realizar la solicitud. ' + err,
              icon: 'success',
              type: 'danger',
            });
            this.loading = false;
          });
      },
    },
  };
</script>
